<template>
  <modal
    :width="removeSeries ? 400 : 300"
  >
    <div class="content">
      <div>
        {{ text }}
      </div>
<!--      <custom-checkbox-->
<!--        class="w-100"-->
<!--        :checked="checked"-->
<!--        :label="'Pobrać opłatę od klientów?'"-->
<!--        @checkChange="changeCheck"-->
<!--      />-->
      <div class="buttons">
        <custom-button
          class="accept-button"
          button-name="Usuń"
          @click="$emit('remove', { removeWithPeriodic: false })"
        />
        <custom-button
          v-if="removeSeries"
          class="accept-button"
          button-name="Usuń serie"
          @click="$emit('remove', { removeWithPeriodic: true })"
        />
        <custom-button
          class="cancel-button"
          button-name="Anuluj"
          @click="$emit('cancel')"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import { ref } from 'vue';
import Modal from './Modal.vue';
import CustomButton from '../common/CustomButton.vue';
// import CustomCheckbox from '../common/CustomCheckbox.vue';

export default {
  name: 'RemoveModal',
  components: { CustomButton, Modal },
  props: {
    text: String,
    removeSeries: {
      default: false,
      type: Boolean,
    },
  },
  setup() {
    const checked = ref(false);

    function changeCheck() {
      checked.value = !checked.value;
    }

    return {
      checked,
      changeCheck,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.content {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  .buttons {
    display: flex;
    justify-content: space-around;
    width: 100%;

    button {
      border-radius: 5px;
      color: $white;
      height: 30px;
      margin-top: 20px;
      width: 100px;
    }

    .accept-button {
      border: 1px solid $blue;
      background-color: $blue;
    }

    .cancel-button {
      border: 1px solid $grey;
      background-color: $grey;
    }
  }
}
</style>
